import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import NoPermissionIcon from "assets/customIcons/emptyTable/NoPermissionIcon";
import { body1SemiBoldStyles } from "shared";

import { NoPermissionsProps } from "./types";

const NoPermission = ({ customStyle }: NoPermissionsProps) => {
    const { t } = useTranslation();

    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                alignItems: "center",

                "& > svg": {
                    fontSize: "96px",
                    margin: "16px 0"
                },

                "& > div": {
                    ...body1SemiBoldStyles,
                    textAlign: "center"
                },

                ...customStyle
            })}
        >
            <NoPermissionIcon />

            <div>{t("Table##empty table##no permission##title")}</div>
        </div>
    );
};

export default NoPermission;
